export default __webpack_public_path__ + "static/media/Scenery05.292fc5e3.jpg";